import React, {useState, useEffect} from "react"

function Debrief() {
    const [webLinks] = useState({
        twitter: "https://twitter.com/ParadoxParlours",
        facebook: "https://www.facebook.com/paradoxparlours",
        instagram: "https://www.instagram.com/paradoxparlours"
    })
    
    const socialMedia = [
        {
            id: 0,
            name: "twitterSocialMedia",
            linkId: webLinks.twitter
        },
        {
            id: 1,
            name: "facebookSocialMedia",
            linkId: webLinks.facebook
        },
        {
            id: 2,
            name: "instagramSocialMedia",
            linkId: webLinks.instagram
        }
    ]
    
    useEffect(() => {
        const storedKey = localStorage.getItem("localKey")
        if (storedKey) {
            localStorage.removeItem("localKey")
        }
    },[])
    
    function handleClick(event) {
        const {name} = event.target
        console.log(name)
        window.location.href = name
    }
    
    const socialMediaButtons = socialMedia.map(social => {
        return <button key={social.id} className={"socialMedia " + social.name} name={social.linkId} onClick={handleClick} target="_blank"></button>
    })
    
    return (
        <main>
            <h1 className="debriefText">THANKS FOR PLAYING!</h1>
            
            <div className="imageTextWrapper">
                <img src="images/larryDoor.jpg" alt="office door of Larry Maxwell" className="debriefPhoto" />
            </div>
            
            <h3 className="debriefText">We hope you enjoyed playing The Disappearing Diamond. Show the world your awesomness by sharing a team selfie online. Don't forget to tag us and remember to keep the secrets. </h3>
            
            <div className="imageTextWrapper socialMediaWrapper">
                {socialMediaButtons}
            </div>
            
            <h3 className="debriefText">See you on the next case!</h3>
            <div id="mainCornerCut"></div>
        </main>
    )
}

export default Debrief